<template lang="pug">
v-card.pa-6(max-width="500", max-height="calc(100vh - 150px)"  )
  .mb-4
    h3 Nuevo ticket
  .fd-column.flex-1
    .d-flex
      v-autocomplete(
        v-model='tipoTicketSeleccionado'
        :items='tiposTicket'
        label="Tipos de ticket"
        placeholder="Selecciona una opcion"
        item-text="name"
        return-object
        item-value="id"
        dense,
      )
    .d-flex
      .flex-1.d-flex
        v-text-field(  dense type="number" ref="documento"  label="Numero de contrato" v-model="numeroContrato" @keyup.enter="fetchEquipos()" hide-details)
        v-btn(color='info' :block="isMovil" :small="!isMovil" @click="fetchEquipos")
          | buscar
    .d-flex.fd-column.mt-4(v-if="usuariosContrato.length")
      span.font-size-11
        | Cuentas registradas para este cliente
      v-radio-group.my-1(v-model="usuarioSeleccionado" row hide-details v-if="usuarioSeleccionado.length > 1")
        v-radio(:label="`${usuario.razonSocial} (${usuario.usuario})`", :value='usuario.usuario' v-for="(usuario, index) in usuariosContrato" :key="index" hide-details )
      span.font-size-12.text-muted(v-else)
        | El ticket se generará con el usuario {{usuarioSeleccionado}}
    .d-flex(v-if="modelosAgrupados.length")
      .flex-1.mt-4(v-if="!equiposDelModeloFiltrados.length")
        v-autocomplete(
          :loading="isGettingEquipos"
          v-model='modeloSeleccionado'
          :items='modelosAgrupados'
          label="Listado de modelos que tienes en contrato"
          placeholder="Realiza la busqueda por el modelo"
          item-value="modelo"
          return-object
          dense,
          hide-details,
          @change="seleccionarModelo"
        )
          template(v-slot:selection='data')
              span.font-weight-700.font-size-12 {{ data.item.modelo }}
          template(v-slot:item='data')
            v-list-item-content
              v-list-item-title.font-weight-700(v-html='data.item.modelo')
              v-list-item-subtitle
                span.font-size-11.text-muted {{`${data.item.cantidad} Equipo(s)`}}
      .flex-1(v-if="!serieSeleccionado && equiposDelModeloFiltrados.length")
        .d-flex.ai-center.mt-4(:class="isMovil && 'fd-column'")
          v-btn(color="info", @click="limpiarModelo()" :class="isMovil && 'mb-2'")
            v-icon keyboard_arrow_left
          v-autocomplete.mx-4(
            :items='equiposDelModeloFiltrados'
            :label="`Listado de equipos del modelo ${modeloSeleccionado.modelo}`"
            placeholder="Realiza la busqueda por la descripción"
            dense,
            item-value="serie"
            item-text="serie"
            return-object
            hide-details,
            v-model="serieSeleccionado"
          )
            //- @change="agregarNuevoTicket"
            template(v-slot:item='data')
              v-list-item-content
                v-list-item-title.font-weight-700(v-html='data.item.serie')
                v-list-item-subtitle
                  span.font-size-11 {{data.item.descripcionArticulo}}
    v-card.pa-2.mt-4(dense,  color="background" v-if="serieSeleccionado")
      v-list-item
        //- v-list-item-avatar(color="primary")
        //-   v-icon(color="white") print
        v-list-item-content.py-0
          v-list-item-title
            small.font-weight-700 {{ `#${serieSeleccionado.numeroContrato}` }} - &nbsp;
            small.font-weight-700 {{ serieSeleccionado.modelo }} - &nbsp;
            small.font-weight-700.primary--text {{serieSeleccionado.serie}}
          v-list-item-subtitle.info--text.font-weight-700.font-size-12 {{serieSeleccionado.descripcionArticulo}}
          v-list-item-subtitle.font-weight-700.font-size-12 {{serieSeleccionado.direccionMaquina}} - ({{serieSeleccionado.descripcionUbigeoMaquina}})
          //- v-list-item-subtitle.font-weight-700.font-size-12 {{tipoTicketSeleccionado}}
          //- v-list-item-subtitle.font-weight-700.font-size-12 {{serieSeleccionado}}
        v-list-item-action
          v-btn(color="info", small, @click="limpiarSerie()")
            v-icon(size="17") keyboard_arrow_left
  .d-flex.mt-8
    v-btn.flex-1.mr-5(color='primary' :block="isMovil"    @click="limpiarTodo()")
      small Cancelar
    v-btn.flex-1(color='success' :block="isMovil" :disabled="!serieSeleccionado"  @click="procesoGenerarTickets()")
      small Registrar
</template>
<script>
import Router from '../router/dispatcher'
import { apiGet, apiPost, notify } from '../util/general'
export default {
  data () {
    return {
      isGettingEquipos     : false,
      isLoadingProceso     : false,
      modeloSeleccionado : [],
      tiposTicket : [
        {
          id : 'solicitúd de insumo',
          name : 'Solicitud de insumo'
        },
        {
          id : 'incidencia con equipo',
          name : 'Incidencia con equipo'
        }
      ],
      modelosAgrupados : [],
      equiposDelModelo : [],
      usuariosContrato : [],
      usuarioSeleccionado : '',
      tipoTicketSeleccionado : 'incidencia con equipo',
      numeroContrato : '',
      serieSeleccionado : '',
      codigoFallaGeneral : 100000
    }
  },
  created () {
  },
  computed : {
    isMovil () {
      var vm = this
      return vm.$vuetify.breakpoint.smAndDown
    },
    equiposDelModeloFiltrados () {
      var vm = this
      return vm.equiposDelModelo.filter(e => e.serie !== vm.serieSeleccionado)
    }
  },
  methods : {
    limpiarSerie () {
      var vm = this
      vm.serieSeleccionado       = ''
    },
    limpiarModelo () {
      var vm = this
      vm.equiposDelModelo       = []
    },
    limpiarTodo () {
      var vm = this
      vm.equiposDelModelo       = []
      vm.modeloSeleccionado       = []
      vm.numeroContrato = ''
      vm.serieSeleccionado = ''
      vm.usuarioSeleccionado = ''
      vm.usuariosContrato = []
      vm.close()
    },
    seleccionarModelo (seleccionado) {
      var vm = this
      if (seleccionado) vm.equiposDelModelo  = seleccionado.equipos
    },
    fetchEquipos () {
      var vm = this
      if (!vm.numeroContrato) {
        notify(vm, 'error', 'Error', `Por favor ingrese el numero de contrato`)
        return;
      }

      vm.isGettingEquipos = true
      vm.$store.dispatch('transaccion', { isProceso : true, message : `Obteniendo listado de equipos` })
      var obj = {
        numeroContrato: vm.numeroContrato
      }
      apiGet(vm, '/cliente/serie/agrupado/all', obj, function (data) {
        vm.modelosAgrupados = data.equiposAgrupados
        vm.verificarUsuarioAntesCrearTicket(function (err, usuarios) {
          if (err) {
            notify(vm, 'error', 'Error', err.message)
            vm.isLoadingProceso = false
            return;
          }

          vm.usuariosContrato = usuarios
          vm.usuarioSeleccionado = usuarios[0].usuario

          vm.isGettingEquipos = false
          vm.$store.dispatch('transaccion', { isProceso : false })
        })
      }, function (error) {
        vm.isGettingEquipos = false
        notify(vm, 'error', 'Error', error.message)
        vm.$store.dispatch('transaccion', { isProceso : false })
      })
    },
    goTo (page) {
      Router.push(page)
    },
    procesoGenerarTickets () {
      var vm = this
      vm.isLoadingProceso = true
      if (!vm.tipoTicketSeleccionado) {
        notify(vm, 'error', 'Error', `Por favor seleccione una categoria para el ticket`)
        vm.isLoadingProceso = false
        return;
      }

      if (!vm.serieSeleccionado.serie) {
        notify(vm, 'error', 'Error', `Por favor seleccione una serie`)
        vm.isLoadingProceso = false
        return;
      }

      if (!vm.usuarioSeleccionado) {
        notify(vm, 'error', 'Error', `Seleccione un usuario valido`)
        vm.isLoadingProceso = false
        return;
      }

      if (!vm.codigoFallaGeneral) {
        notify(vm, 'error', 'Error', `Por favor seleccione una falla`)
        vm.isLoadingProceso = false
        return;
      }

      var obj = {
        ticket     : {
          serie: vm.serieSeleccionado.serie,
          tipo : vm.tipoTicketSeleccionado.id,
          insumo : [],
          usuario: vm.usuarioSeleccionado,
          falla : {
            codigoFallaGeneral : vm.codigoFallaGeneral
          }
        },
        isPlantilla : 1,
        isGenerarIT: false
      }

      apiPost(vm, '/ticket/registrar', obj, function (data) {
        vm.isLoadingProceso = false
        vm.$store.dispatch('transaccion', { isProceso : false })
        notify(vm, 'success', 'Exito', 'Los tickets se generarón correctamente')
        vm.close()
        vm.goTo(`/ticket/${data.numero}`)
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      })
    },
    verificarUsuarioAntesCrearTicket (callback) {
      var vm = this
      var obj = {
        numeroContrato: vm.numeroContrato
      }
      apiGet(vm, '/usuario/obtener/por/contrato', obj, function (data) {
        callback(null, data.usuarios || [])
      }, function (error) {
        callback(error)
      })
    },
    close () {
      var vm = this
      vm.$emit('close')
    },
    onUnmounted () {
      var vm = this
      vm.close()
    }
  }
}
</script>



// WEBPACK FOOTER //
// c_card_generate_ticket.vue?6f722959